// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import React, { useCallback, useContext, useState } from "react";
import {
  getCopyCatMatchValidator,
  getMasterMatchValidator,
  validateEmail,
  validatePasswordLength,
} from "../ui/Questionnaire/validators/QuestionnaireValidators";

import AuthenticationCard from "./AuthenticationCard";
import { CustomerContext } from "components/App/DashboardApp";
import { Link } from "react-router-dom";
import PageContent from "../ui/PageContent";
import { Question } from "../ui/Questionnaire/QuestionnaireTypes";
import QuestionnaireForm from "../ui/Questionnaire/Questionnaire";
import QuestionnaireInput from "components/ui/Questionnaire/QuestionnaireInput";
import { createUser } from "store/auth";
import { getFirebaseApp } from "../Firebase/Firebase";

export default () => {
  const [error, setError] = useState<string | null>(null);
  const customerContext = useContext(CustomerContext);
  const orgId = customerContext.id;

  const onSubmit = useCallback(
    async (event: React.FormEvent, questions: { [key: string]: Question }) => {
      event.preventDefault();
      const email = questions.email.value;
      if (!email) {
        throw new Error("No email provided");
      }
      const password = questions.password.value;
      const firebase = await getFirebaseApp();
      try {
        const userUID = await createUser(email, password!);
        await firebase.createUser({ orgId, userUID, email });
      } catch (error) {
        setError(error.message);
      }
    },
    [orgId]
  );

  return (
    <PageContent>
      <AuthenticationCard title="Sign Up">
        <QuestionnaireForm
          onSubmit={onSubmit}
          submitLabel="Create Account"
          error={error}
        >
          <QuestionnaireInput
            icon="envelope"
            label="Email"
            mandatory={true}
            name="email"
            placeholder="Enter your email"
            type="email"
            validators={[validateEmail]}
          />
          <QuestionnaireInput
            icon="lock"
            label="Password"
            mandatory={true}
            name="password"
            type="password"
            validators={[
              validatePasswordLength,
              getCopyCatMatchValidator("password2"),
            ]}
          />
          <QuestionnaireInput
            icon="lock"
            label="Re-Enter Password"
            mandatory={true}
            name="password2"
            type="password"
            validators={[getMasterMatchValidator("password")]}
          />
        </QuestionnaireForm>
        <div>
          <Link to={getPath(ROUTE_DEFINITIONS.LOGIN)}>
            Login with an existing account
          </Link>
        </div>
      </AuthenticationCard>
    </PageContent>
  );
};
